import { createStyles } from '@zn-material-ui'

export default () =>
  createStyles({
    checkboxCon: {
      width: '100%',
      fontSize: '14px',
      color: '#1F1F1F',
      fontWeight: 200,
      marginLeft: '-10px',
      marginTop: '16px',
    },
    link: {
      color: '#4E8FFF',
    }
  })
